import { Typography, TypographyProps } from "@mui/material";
import { useEffect } from "react";
import { convertMessage } from "../../../utils";

export type TRichTypographyProps = TypographyProps & {
	id: string;
	text: string;
	rich?: boolean;
};

export function RichTypography({
	id,
	text,
	rich = true,
	...props
}: TRichTypographyProps) {
	useEffect(() => {
		const textElement = document.getElementById(id);
		if (!textElement) {
			return;
		}

		if (rich) {
			textElement.innerHTML = convertMessage(text);
		} else {
			textElement.innerText = text;
		}
	}, [id, text, rich]);

	return <Typography id={id} {...props} />;
}
